import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
  Avatar,
  FormControlLabel,
  Switch,
} from "@mui/material";

const ViewEditUser = ({ user, onSubmit, onClose, isEditable, isSuperuser }) => {
  const [readOnly, setReadonly] = useState(true);
  const [form, setForm] = useState(user);

  useEffect(() => {
    setForm(user);
    setReadonly(true);
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => setReadonly(false);

  const handleSubmit = () => {
    onSubmit(form);
    setReadonly(true);
  };

  if (!user) {
    return (
      <Card sx={{ p: 3, bgcolor: "#f5f8fa" }}>
        <Typography variant="body1" color="text.secondary">
          Choose a user to view or edit their details.
        </Typography>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 4,
        width: 300,
        overflow: "hidden",
        bgcolor: "#ffffff",
        border: "1px solid #e0e0e0",
      }}
    >
      <Box
        sx={{
          height: 140,
          background: "linear-gradient(135deg, #0d47a1, #1976d2)",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Avatar
          src={user.portrait || undefined}
          sx={{
            fontSize: "3.5rem",
            width: 96,
            height: 96,
            border: "4px solid white",
            position: "absolute",
            bottom: -48,
          }}
        >
          {user.firstName?.[0] || "?"}
        </Avatar>
      </Box>

      <CardContent sx={{ mt: 6 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", mb: 2, color: "#0d47a1", textAlign: "center" }}
        >
          User Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="First Name"
            name="firstName"
            value={form.firstName || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            slotProps={{ input: { readOnly: readOnly } }}
          />
          <TextField
            label="Last Name"
            name="lastName"
            value={form.lastName || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            slotProps={{ input: { readOnly: readOnly } }}
          />
          <TextField
            label="Email"
            name="email"
            value={form.email || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            slotProps={{ input: { readOnly: readOnly } }}
          />
          <TextField
            label="Phone Number"
            name="phoneNumber"
            value={form.phoneNumber || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            slotProps={{ input: { readOnly: readOnly } }}
          />
          { isSuperuser && (
          <>
          <FormControlLabel
            control={
              <Switch
                checked={!!form.isDemo}
                disabled={readOnly}
                onChange={(e) => setForm((prev) => ({ ...prev, isDemo: !!e.target.checked}))} 
              />
            }
            label="Is Demo User"
          />
          <FormControlLabel
            control={
              <Switch
                checked={!!form.isActive}
                disabled={readOnly}
                onChange={(e) => setForm((prev) => ({ ...prev, isActive: !!e.target.checked}))} 
              />
            }
            label="Is Active User"
          />
          </>
          )}
          {isEditable && (
            <Box display="flex" gap={2} justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                onClick={onClose}
                sx={{
                  bgcolor: "#2e7d32",
                  "&:hover": { bgcolor: "#1b5e20" },
                  fontWeight: "bold",
                }}
              >
                Close
              </Button>
              {readOnly ? (
                <Button
                  variant="contained"
                  onClick={handleEdit}
                  sx={{
                    bgcolor: "#1976d2",
                    "&:hover": { bgcolor: "#0d47a1" },
                    fontWeight: "bold",
                  }}
                >
                  Edit
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    bgcolor: "#2e7d32",
                    "&:hover": { bgcolor: "#1b5e20" },
                    fontWeight: "bold",
                  }}
                >
                  Submit
                </Button>
              )}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ViewEditUser;
